import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import { NotificationModel } from 'shared/models';
import { UiIcon } from 'shared/uikit';
import { ICONS } from 'shared/constants';

import { VmNotificationIcon } from './components/VmNotificationIcon';
import * as components from './components';

import './styles.scss';

type ComponentName = keyof typeof components;

type PropsType = {
    notification: NotificationModel;
    isLight?: boolean;
    onClose?: () => void;
    onDelete?: (notification: NotificationModel) => void;
    onHover?: (notification: NotificationModel) => void;
};

export const VmNotification = observer((
    {
        notification,
        onDelete = () => undefined,
        onClose = () => undefined,
        onHover = () => undefined,
    }: PropsType,
) => {
    const componentName = (notification.type?.id ? ('VmNotification' + notification.type.id.replace('Notification', '')) : 'NotFound') as ComponentName;
    const VmNotificationContent = components[componentName] || null;

    useEffect(() => {
        const componentName = (notification.type?.id ? ('VmNotification' + notification.type.id.replace('Notification', '')) : 'NotFound') as ComponentName;
        const VmNotificationContent = components[componentName] || null;
        if (!VmNotificationContent) {
            onDelete(notification);
        }
    }, [notification, onDelete]);

    if (!VmNotificationContent) {
        return null;
    }

    return (
        <div
            onMouseEnter={() => onHover(notification)}
            className={classnames('vm-notification', {
                'vm-notification--new': !notification.readAt,
            })}
        >
            <div className="vm-notification__icon">
                <VmNotificationIcon notification={notification} />
            </div>
            <div className="vm-notification__aside">
                <div className="vm-notification__date">{notification.createdAtFormatted()}</div>
                <div className="vm-notification__close" onClick={() => onDelete(notification)}>
                    <UiIcon icon={ICONS.CLOSE} size={16} />
                </div>
            </div>
            <VmNotificationContent
                notification={notification}
                onClose={onClose}
                onDelete={onDelete}
            />
        </div>
    );
});
